import { FC } from 'react';
import styled from 'styled-components';
import Button from '../Button';
import ArrowLeftIcon from '../icons/ArrowLeft';
import ArrowRightIcon from '../icons/ArrowRight';

const Container = styled.div`
  border-top: 1px solid var(--gray-200);
  padding: 0.8rem 1.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  overflow-x: auto;
  gap: 0.375rem;
`;

const Pages = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  & > div {
    color: var(--gray-500);
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
    cursor: pointer;
  }
  & > .active {
    background-color: var(--primary-50);
    color: var(--primary-600);
    border-radius: 0.5rem;
  }
`;

type ListFootProps = {
  pages?: number;
  page: number;
  setPage: (page: number) => void;
};

const ListFoot: FC<ListFootProps> = ({ pages, page, setPage }) => {
  return (
    <Container>
      {page ? (
        <Button
          variant="outlined"
          icon={<ArrowLeftIcon />}
          onClick={() => page && setPage(page - 1)}
        >
          Précédent
        </Button>
      ) : (
        <div />
      )}
      <Pages>
        {!pages
          ? null
          : (pages < 8
              ? // [0,1,2,3,4,5,6,7]
                Array.from({ length: pages }, (_, i) => i)
              : // All the examples from here are with 11 pages
              [0, 1, pages - 2, pages - 1].includes(page) // Checks if the page is on the extremity
              ? // [0, 1, 2, ..., 8, 9, 10]
                [0, 1, 2, -1, pages - 3, pages - 2, pages - 1]
              : page !== 2 && page !== pages - 3
              ? // [0, ..., 4, 5, 6, ..., 10]
                [0, -1, page - 1, page, page + 1, -1, pages - 1]
              : page === 2
              ? // [0, 1, 2, 3, ..., 9, 10]
                [0, 1, 2, 3, -1, pages - 2, pages - 1]
              : // [0, 1, ..., 7, 8, 9, 10]
                [0, 1, -1, pages - 4, pages - 3, pages - 2, pages - 1]
            ).map((i, idx) => (
              <PageItem i={i} page={page} setPage={setPage} key={idx} />
            ))}
      </Pages>
      {pages && page < pages - 1 ? (
        <Button
          variant="outlined"
          icon={<ArrowRightIcon />}
          iconSide="right"
          onClick={() => {
            pages !== undefined && page < pages - 1 && setPage(page + 1);
          }}
        >
          Suivant
        </Button>
      ) : (
        <div />
      )}
    </Container>
  );
};

type PageItemProps = {
  page: number;
  setPage: (page: number) => void;
  i: number;
};
const PageItem: FC<PageItemProps> = ({ page, setPage, i }) => {
  return (
    <div
      className={i === page ? 'active' : ''}
      onClick={() => {
        i > -1 && setPage(i);
      }}
    >
      {i === -1 ? '...' : i + 1}
    </div>
  );
};

export default ListFoot;
